import { Box } from '@mui/material';

import type { RefuelsDateRange } from '../../types/RefuelsDateRange.types';

type RefuelDateTabLabelProps = {
  selectedDates: RefuelsDateRange | undefined;
  label: string;
};

export function RefuelDateTabLabel({ selectedDates, label }: RefuelDateTabLabelProps) {
  return (
    <Box
      data-qa-element-id={`date_selector_tab_label_${selectedDates?.from.toLocaleDateString()}_${selectedDates?.to.toLocaleDateString()}`}
    >
      {label}
    </Box>
  );
}
